import React from 'react'

const CrossFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='31'
    height='30'
    viewBox='2.8 2 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.3339 21.2501L15.8339 16.7501L20.3339 21.2501L22.0839 19.5001L17.5839 15.0001L22.0839 10.5001L20.3339 8.75012L15.8339 13.2501L11.3339 8.75012L9.58387 10.5001L14.0839 15.0001L9.58387 19.5001L11.3339 21.2501ZM15.8339 27.5001C14.1047 27.5001 12.4797 27.172 10.9589 26.5158C9.43804 25.8595 8.11512 24.9689 6.99012 23.8439C5.86512 22.7189 4.9745 21.396 4.31825 19.8751C3.662 18.3543 3.33387 16.7293 3.33387 15.0001C3.33387 13.271 3.662 11.646 4.31825 10.1251C4.9745 8.60429 5.86512 7.28137 6.99012 6.15637C8.11512 5.03137 9.43804 4.14075 10.9589 3.4845C12.4797 2.82825 14.1047 2.50012 15.8339 2.50012C17.563 2.50012 19.188 2.82825 20.7089 3.4845C22.2297 4.14075 23.5526 5.03137 24.6776 6.15637C25.8026 7.28137 26.6932 8.60429 27.3495 10.1251C28.0057 11.646 28.3339 13.271 28.3339 15.0001C28.3339 16.7293 28.0057 18.3543 27.3495 19.8751C26.6932 21.396 25.8026 22.7189 24.6776 23.8439C23.5526 24.9689 22.2297 25.8595 20.7089 26.5158C19.188 27.172 17.563 27.5001 15.8339 27.5001Z'
      fill='currentcolor'
    />
  </svg>
)

export default CrossFilledIcon
